import { createContext, useContext } from 'react';
import type { AdminUser } from '../hooks/useAuth';

interface AuthContextType {
  admin: AdminUser | null;
  loading: boolean;
  login: (email: string, password: string) => Promise<string | null>;
  logout: () => Promise<void>;
  canDelete: boolean;
  isSuperAdmin: boolean;
}

export const AuthContext = createContext<AuthContextType>({
  admin: null,
  loading: false,
  login: async () => null,
  logout: async () => {},
  canDelete: false,
  isSuperAdmin: false,
});

export function useAuthContext() {
  return useContext(AuthContext);
}
